export default [
  {
    number: 28,
    class: 'muted',
    title: ''
  },
  {
    number: 29,
    class: 'muted',
    title: ''
  },
  {
    number: 30,
    class: 'muted',
    title: ''
  },
  {
    number: 1,
    class: 'off',
    title: 'Dia do Trabalho - Não haverá aula'
  },
  {
    number: 2,
    class: '',
    title: ''
  },
  {
    number: 3,
    class: '',
    title: ''
  },
  {
    number: 4,
    class: '',
    title: ''
  },
  {
    number: 5,
    class: '',
    title: ''
  },
  {
    number: 6,
    class: '',
    title: ''
  },
  {
    number: 7,
    class: '',
    title: ''
  },
  {
    number: 8,
    class: '',
    title: ''
  },
  {
    number: 9,
    class: 'class',
    title: 'dev.learn("básico") - JS part.2 - 14:00 as 15:40'
  },
  {
    number: 10,
    class: '',
    title: ''
  },
  {
    number: 11,
    class: 'class',
    title: `dev.learn("básico") - JS part.2 - 13:00 as 14:40 - 
    dev.learn("avançado") - A Definir- 15:00 as 16:40 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 12,
    class: '',
    title: ''
  },
  {
    number: 13,
    class: '',
    title: ''
  },
  {
    number: 14,
    class: '',
    title: ''
  },
  {
    number: 15,
    class: '',
    title: ''
  },
  {
    number: 16,
    class: 'class',
    title: `dev.learn("básico") - JS part.3 - 14:00 as 15:40 - 
    Inscrição HackathonUSP`
  },
  {
    number: 17,
    class: 'subscribe',
    title: 'Inscrição HackathonUSP'
  },
  {
    number: 18,
    class: 'class',
    title: `dev.learn("básico") - JS part.3 - 13:00 as 14:40 - 
    dev.learn("avançado") - A Definir- 15:00 as 16:40 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 19,
    class: '',
    title: ''
  },
  {
    number: 20,
    class: '',
    title: ''
  },
  {
    number: 21,
    class: '',
    title: ''
  },
  {
    number: 22,
    class: '',
    title: ''
  },
  {
    number: 23,
    class: 'class',
    title: 'dev.learn("básico") - JS part.4 - 14:00 as 15:40'
  },
  {
    number: 24,
    class: '',
    title: ''
  },
  {
    number: 25,
    class: 'class',
    title: `dev.learn("básico") - JS part.4 - 13:00 as 14:40 - 
    dev.learn("avançado") - A Definir- 15:00 as 16:40 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 26,
    class: '',
    title: ''
  },
  {
    number: 27,
    class: '',
    title: ''
  },
  {
    number: 28,
    class: '',
    title: ''
  },
  {
    number: 29,
    class: '',
    title: ''
  },
  {
    number: 30,
    class: '',
    title: ''
  },
  {
    number: 31,
    class: '',
    title: ''
  },
  {
    number: 1,
    class: 'muted',
    title: ''
  },
  {
    number: 2,
    class: 'muted',
    title: ''
  },
  {
    number: 3,
    class: 'muted',
    title: ''
  },
  {
    number: 4,
    class: 'muted',
    title: ''
  },
  {
    number: 5,
    class: 'muted',
    title: ''
  },
  {
    number: 6,
    class: 'muted',
    title: ''
  },
  {
    number: 8,
    class: 'muted',
    title: ''
  },
  {
    number: 9,
    class: 'muted',
    title: ''
  },
]